import { useEffect } from 'react';

import { useCookiesStore } from '@/store.js';

import { setSentryConsent } from '../sentry.js';

const useSentryConsent = () => {
    const functionalCookies = useCookiesStore((state) => state.functionalCookies);

    useEffect(() => {
        setSentryConsent(functionalCookies);
    }, [functionalCookies]);
};

export default useSentryConsent;
